/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetCurrenciesResponseJson } from './get-currencies-response-json';
import { GetCurrenciesResult } from '../results/get-currencies-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { CurrencyDto } from '../models/currency-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetCurrenciesResponse extends ResponseWithErrorGeneric<GetCurrenciesResponseJson, GetCurrenciesResult> implements IResponseWithErrorGeneric<GetCurrenciesResult> {
  public currencies: CurrencyDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetCurrenciesResponse>) {
    super(response, GetCurrenciesResult.Error);
    if (this.result !== GetCurrenciesResult.Success) {
      return;
    }

    if (this.body.currencies != null)
      this.currencies = this.body.currencies;
  }
  //</custom-body>
}
